import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		female: {
			// /result_complete?safe&mock-data&utm_source=FB&country=DE&area=female&exp=web_send_calculated_vat_eu~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_send_calculated_vat_eu/female'
					),
			},
		},
		male: {
			// /result_complete?safe&mock-data&utm_source=FB&country=DE&area=male&exp=web_send_calculated_vat_eu~1&sex=male
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_send_calculated_vat_eu/male'
					),
			},
		},
		'activity-female-walking': {
			// /result_complete?safe&mock-data&utm_source=FB&country=DE&area=activity-female-walking&exp=web_send_calculated_vat_eu~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_send_calculated_vat_eu/activity-female-walking'
					),
			},
		},
		'activity-male-walking': {
			// /result_complete?safe&mock-data&utm_source=FB&country=DE&area=activity-male-walking&exp=web_send_calculated_vat_eu~1&sex=male
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_send_calculated_vat_eu/activity-male-walking'
					),
			},
		},
		'activity-female-yoga': {
			// /result_complete?safe&mock-data&utm_source=FB&country=DE&area=activity-female-yoga&exp=web_send_calculated_vat_eu~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_send_calculated_vat_eu/activity-female-yoga'
					),
			},
		},
	},
]

export default config
